<template>
  <b-form-group :label="label" :invalid-feedback="fieldError(name)" :state="fieldState(name)">
<!--    <b-btn size="sm" variant="outline-secondary" @click="showFileManager = true; fileManagerTarget = 'excerptEditor'">Вставить файл</b-btn>-->
<!--    <br><br>-->
    <editor
        :value="value"
        @init="initEditor"
        @input="$emit('input', $event)"
        lang="html"
        width="100%"
        height="300"
        ref="editor"></editor>
  </b-form-group>
</template>

<script>
export default {
  components: {
    editor: require('vue2-ace-editor')
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default () {
        return `editor-input-${this._uid}`
      }
    },
    value: String,
    label: String,
    name: String
  },
  methods: {
    initEditor () {
      require('brace/mode/html')
      require('brace/mode/javascript')
      require('brace/theme/chrome')
    }
  }
}
</script>
